import React from 'react';
import PropTypes from 'prop-types';
import { DropdownItem, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { linkHandler } from 'utils/linkHandler';

// See https://github.com/reactstrap/reactstrap/issues/83#issue-168537815
// on how to connect NavLink with react-router-dom's link
export const BrandLink = () => (
  <NavLink className="navbar-brand p-0" tag={Link} to={linkHandler.get('home')}>
    Balloon Home
  </NavLink>
);

export const LogoutLink = ({ onLogout }) => (
  <DropdownItem tag={Link} onClick={onLogout} to={linkHandler.get('home')}>
    Logout
  </DropdownItem>
);

LogoutLink.propTypes = {
  onLogout: PropTypes.func.isRequired
};

export const ProfileLink = ({ onClick }) => (
  <DropdownItem tag={Link} to={linkHandler.get('profilePersonalData')} onClick={onClick} data-cy-name="profile-link">
    Mein Profil
  </DropdownItem>
);

export const RegistrationLink = () => (
  <NavItem>
    <NavLink tag={Link} to={linkHandler.get('signup')}>
      Registrieren
    </NavLink>
  </NavItem>
);

export const LoginLink = () => (
  <NavItem>
    <NavLink tag={Link} to={linkHandler.get('login')}>
      Anmelden
    </NavLink>
  </NavItem>
);

export const SubscribeLink = ({ onSubscribe }) => (
  <NavItem>
    <NavLink tag={Link} onClick={onSubscribe} to={linkHandler.get('plans')}>
      Preise
    </NavLink>
  </NavItem>
);

SubscribeLink.propTypes = {
  onSubscribe: PropTypes.func.isRequired
};
